import { AnalyticsType } from '@invideoio/web-shared/types/Analytics';
import { Analytics } from '@invideoio/web-shared/utils/analytics';
import { AnalyticsUtils } from '@invideoio/web-shared/utils/analytics/AnalyticsUtils';
import { IDataBraze } from '@invideoio/web-shared/utils/analytics/Braze';
import { sanitizeParams } from '@invideoio/web-shared/utils/auth/check-params';
import {
  ClickCtaAnalytics,
  ClickExportAnalytics,
  RequestEditorAnalytics,
} from '../types/analytics';

export enum AmplitudeEvents {
  appLoad = 'App Load',
  clickUploadButton = 'Click on Upload Media',
  uploadStart = 'Upload Start',
  clickSignUp = 'Click Signup',
  clickLogin = 'Click Login',
  toolGetLink = 'Tool Get Link',
  uploadMedia = 'Upload Media',
  clickSupport = 'Click Support',
  closeToolEditor = 'Close Tool Editor',
  clickDone = 'Click Done Tools',
  clickBackToToolEditor = 'Go Back To Tool Editor',
  exportToolVideo = 'Export Tool Video',
  downloadVideo = 'Download in Tool',
  openVideoInMainEditor = 'Open from Tool to Main Editor',
  clickLearnMore = 'Click Learn More',
  toolEditorLoad = 'View Tool Editor',
}

export const sendAmplitudeAnalyticEvent = (
  eventName: string,
  eventData: any = {},
) => {
  Analytics.send(AnalyticsType.AMPLITUDE, {
    eventName,
    eventProperties: {
      Pagetype: AnalyticsUtils.getPage(),
      Url: sanitizeParams(),
      ...eventData,
    },
  });
};

export const sendBrazeAnalyticEvent = (data: IDataBraze) => {
  Analytics.send(AnalyticsType.BRAZE, {
    eventName: data.eventName,
    eventProperties: data?.eventProperties,
    userProperties: data?.userProperties,
  });
};

export const sendRudderStackAnalyticEvent = (
  data: ClickCtaAnalytics | ClickExportAnalytics | RequestEditorAnalytics,
) => {
  const eventName = data.event_name;
  const eventProperties = data.event_properties;
  const userProperties = data.user_properties;
  Analytics.send(AnalyticsType.RUDDER_STACK, {
    eventName,
    eventProperties: {
      ...AnalyticsUtils.commonRudderStackEventProperties(),
      ...AnalyticsUtils.toLowerCaseObject((eventProperties as any) ?? {}),
    },
    userProperties: {
      ...AnalyticsUtils.toLowerCaseObject(userProperties ?? {}),
    },
  });
};

export const sendRudderStackIdentifyAnalytics = () => {
  Analytics.identify(AnalyticsType.RUDDER_STACK);
};
